import { render, staticRenderFns } from "./SwitchArrayView.vue?vue&type=template&id=aed800c2&"
import script from "./SwitchArrayView.vue?vue&type=script&lang=js&"
export * from "./SwitchArrayView.vue?vue&type=script&lang=js&"
import style0 from "./SwitchArrayView.vue?vue&type=style&index=0&id=aed800c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports